const Queston_Answer = [
  {
    question: 'What is Thums Up® ThunderWheels 2026 Promotion?',
    answer: 'The Thums Up® ThunderWheels 2026 promotion (“Promotion”) is a consumer promotion organised by Coca-Cola India Private Limited (“CCIPL”), wherein individuals, upon scanning the QR Code on the Promotion Products (as defined hereinbelow) can participate in and get a chance to win Prize(s) (as defined hereinbelow) in accordance with the terms and conditions of the Promotion available at: https://www.coke2home.com/thunderwheels/tandc.',
  },
  {
    question: 'What are the Prize(s) available to be won?',
    answer: 'During the Promotion Period, Participants on the basis of valid participation, shall get a chance to win the following Prize(s): Daily Prize (Twice per Mobile Number during the Promotion Period): I.	PhonePe Cashback worth up to Rs.100/-  Bumper Prize (Once per Mobile Number during the Promotion Period): One (1) motorcycle of at least 250CC engine capacity.',
  },
  {
    question: 'What is the Promotion duration & timings?',
    answer: 'This Promotion will commence at 00:00:00 hrs Indian Standard Time (“IST”) on 1st June 2026 (“Start Date”) and will continue until 30th September 2026 11:59:59 pm IST (“End Date”) (“Promotion Period”). Participation will only be allowed during 9AM-10PM IST daily (“Daily Promotion Window”). Any entries received outside the Daily Promotion Window and the Promotion Period shall not be eligible for the Prize(s) applicable for that phase and shall not be carried forward to any other promotional scheme ahead.',
  },
  {
    question: ' On which product is this Promotion applicable?',
    answer: "The offer is applicable on purchase of any 250ml, 300ml, 350ml, 400ml, 500ml, 600ml, 740ml, 750ml, 1L, 1.25L, 1.5L, 2L, 2.25L, 2.5L Thums Up® PET packs (“Promotion Product(s)”).",
  },
  {
    question: 'How do I participate in Thums Up® ThunderWheels?',
    // answer: 'Add in order to participate at start - Ex: “In order to participate, need to buy a Thu...”',
    answer: {
      title:
        "In order to participate, need to buy a Thums Up® Promotion Pack, and follow the steps below to participate during the Daily Participation Window within the Promotion Period:",
      steps: [
        "Scan the QR code on a Thums Up® Promotion Product to sign up on the official Thums Up® WhatsApp channel.",
        "Select your State of participation.",
        "Add the unique code from behind the label of the Promotion Product on the ‘Unique Code’ screen & get a chance to win!  Please refer to the Promotion Terms & Conditions for more details.",
      ],
    },
    // answer: 'In order to participate, need to buy a Thums Up® Promotion Pack, and follow the steps below to participate during the Daily Participation Window within the Promotion Period: Step 1: Scan the QR code on a Thums Up® Promotion Product to sign up on the official Thums Up® WhatsApp channel Step 2: Select your State of participation Step 3: Add the unique code from behind the label of the Promotion Product on the ‘Unique Code’ screen & get a chance to win!  Please refer to the Promotion Terms & Conditions for more details.',
  },
  {
    question: 'What is a unique code?',
    answer: 'A unique code is a 10-digit alphanumeric code printed behind the label of the Thums Up® Promotion Product.',
  },
  {
    question: 'How many times can I win during this Promotion?',
    answer: 'You can participate in the Promotion multiple times during the Promotion Period, but you will be eligible to win up to a maximum of one (1) Bumper Prize & two (2) PhonePe Cashbacks per Mobile Number during the Promotion Period.',
  },
  {
    question: 'Where can I check the status of the Prize(s) won?',
    answer: 'All rewards won by you will be visible under ‘My Wins’ section on the official Thums Up® WhatsApp Channel. Please select My Wins from Menu options to check these out.',
  },
  {
    question: 'How can I redeem my Daily Prize(s)?',
    answer: 'If you are a Winner of the Daily Prize(s), you will be notified on the official Thums Up® WhatsApp Channel on your winning status and next steps to redeem your Prize(s). You will be provided with cashback voucher code, PIN and a link to PhonePe site/app for redemption. All digital vouchers must be redeemed latest by 10 December 2026.',
  },
  {
    question: 'I won the Bike! What do I do next? How do I claim my Bike?',
    answer: 'Congratulations! Post winning the bike, you will be provided with a Claim Form on the Thums Up WhatsApp channel (Click on ‘Claim Now’ from the Menu options). Please fill in your details in the Claim Form, within 72 Hours from the time of winning (“Claim Window”). Bikes not claimed within the Claim Window will be forfeited. Post Claim form submission, our authorised Agency will get in touch with you for further process. ',
  },
  {
    question: 'What details do I need to fill in the Claim Form?',
    answer: "You'll need to provide your Full Name, Email ID, PAN Card Number, Complete Address including Pincode State & City.",
  },
  {
    question: 'I won the Thunderwheels Bike but forgot to claim within 72 hours. What happens?',
    answer: 'Unfortunately, if the claim form is not filled within 72 hours of winning the Bike, your bike win will be forfeited. However, you can participate again with a new unique code to try your hand at winning again.',
  },
  {
    question: 'After filling the Claim Form, when will I be contacted?',
    answer: 'Once you successfully submit the claim form, our authorised Agency will get in touch with you for further process within the Bike Prize Redemption Window as communicated by CCIPL/Agency.',
  },
  {
    question: "I don't have a promo bottle. Where can I buy one?",
    answer: 'You can purchase a Thums Up® Promotion Product at your nearest retailer or in case you wish to purchase online, click on "Buy Now" in the chatbot menu options.',
  },
  {
    question: 'Why do I need to enter my State to participate?',
    answer: 'The Promotion’s terms are different in different territories, it is important for us to determine the terms valid in your region so we can activate the right Promotion valid in your region.',
  },
  {
    question: 'I entered my unique code, but I got an error message saying, ‘incorrect code’. What should I do?',
    answer: 'Please make sure you are entering the correct 10-digit unique code from a Thums Up® Promotion Pack. Double-check the code and try again.',
  },
  {
    question: 'I entered my unique code, but I got an error message saying, ‘code is already used’. What should I do?',
    answer: 'Each unique code can only be used once. If you see this message, the code has already been used to participate earlier. Please grab a new Thums Up® promotion pack and try with a fresh code.',
  },
  {
    question: 'How many times can I participate in a day?',
    answer: "You can enter up to 5 unique codes per day (valid or invalid). Once your daily limit is exhausted, you'll need to come back the next day with a new code.",
  },
  {
    question: "I've used up all my tries for today. What do I do?",
    answer: 'Come back any other day between 9 AM – 10 PM with a new unique code from a Thums Up® Promotion Product for more chances to win!',
  },
  {
    question: "Today's rewards seem to already be claimed. Am I too late?",
    answer: "thousands of participants every day. If today's rewards have already been won by other participants, don't worry - many more would be still up for grabs on other days! Come back any other day between 9 AM – 10 PM for another chance to win.",
  },
  {
    question: "I didn't win this time. Can I try again?",
    answer: 'Absolutely! Your next chance to win could be just one unique code away. Grab another Thums Up® Promotion Product and try again.',
  },
  {
    question: 'Where can I find my PhonePe cashback voucher code and PIN?',
    answer: 'Your voucher code and PIN are shared directly in the WhatsApp chatbot when you win. You can also find them anytime under the "My Wins" section in the menu.',
  },
  {
    question: 'How do I redeem my PhonePe Cashback Voucher?',
    answer: {
      title: "Follow these :",
      steps: [
        "Tap the PhonePe redemption link - https://phon.pe/egvProfile",
        "Open the PhonePe app and tap your profile picture on the home screen.",
        'Select "View All Payment Methods".',
        'Scroll to "PhonePe Gift Card" and tap "Add Gift Card" / "Claim Now".',
        'Enter your Gift Card number and PIN, then tap "Claim Now".',
      ],
    },
    // answer: 'Follow these steps: 1.	Tap the PhonePe redemption link - https://phon.pe/egvProfile 2.	Open the PhonePe app and tap your profile picture on the home screen 3.	Select "View All Payment Methods" 4.	Scroll to "PhonePe Gift Card" and tap "Add Gift Card" / "Claim Now" 5.	Enter your Gift Card number and PIN, then tap "Claim Now"',
  },
  {
    question: "I don’t have an Indian mobile number, can I still participate?",
    answer: 'The Promotion is limited to Indian participants and within certain Promotion Territories only. You must possess a valid, 10-digit Indian mobile number in order to participate. Please refer to Promotion Terms & Conditions for more details. ',
  },
  {
    question: 'Can I refer a friend to this campaign?',
    answer: "Yes! Select 'Refer a Friend' from the menu and share your friend's (valid 10-digit, Indian) mobile number to invite them. Once they join, they get a chance to win exciting rewards too!'",
  },
  {
    question: 'What happens after I refer a friend?',
    answer: 'After you enter a valid 10-digit mobile number, your friend will receive an invitation on WhatsApp to join Thums Up® ThunderWheels.',
  },
  {
    question: 'Can I use this chatbot in any other language?',
    answer: 'Yes, the chatbot is also available in following languages: Hindi, English, Bengali, and Gujarati. Select "Change Language" from the menu to chat in any one of these.',
  },
  {
    question: 'How do I opt out of receiving messages from this campaign?',
    answer: 'You can opt out at any time by replying with "Stop", "Unsubscribe", "Quit" or "End" in the chatbot.',
  },
  {
    question: 'I opted out earlier. Can I rejoin?',
    answer: 'Yes! Simply scan the QR code on a Thums Up® Promotion Product again or drop a "Hi" in the chat window to restart your journey.',
  },
  {
    question: 'The Promotion has ended. Can I still check my wins?',
    answer: 'Yes! Even after the campaign ends, you can check your past rewards anytime via "My Wins" in the chatbot menu, until 28th February 2027.',
  },
  {
    question: 'I have other questions. What should I do?',
    answer: 'If you have any further questions regarding the Promotion or are facing issues, please get in touch with us at indiahelpline@coca-cola.com or call us at 1800-208-2653 (Timings: 09:00 am-09:00 pm Mon-Sat, 09:00 am-06:00 pm Sun).',
  },

];

export default Queston_Answer;